import { createSystem, defaultConfig } from '@chakra-ui/react'
import {
	BgColorsRaw,
	BorderRadiusRaw,
	BrandColorsRaw,
	SpacingRaw,
	TextColorsRaw
} from 'commons/design-system/tokens'
import { avatar, button, input } from 'commons/design-system/variants'

const config = {
	strictTokens: false,
	theme: {
		tokens: {
			spacing: {
				'3xs': { value: SpacingRaw['3XS'] },
				'2xs': { value: SpacingRaw['2XS'] },
				xs: { value: SpacingRaw.XS },
				s: { value: SpacingRaw.S },
				sm: { value: SpacingRaw.SM },
				m: { value: SpacingRaw.M },
				ml: { value: SpacingRaw.ML },
				l: { value: SpacingRaw.L },
				xl: { value: SpacingRaw.XL },
				'2xl': { value: SpacingRaw['2XL'] },
				'3xl': { value: SpacingRaw['3XL'] }
			},
			radii: {
				xs: { value: BorderRadiusRaw.XS },
				s: { value: BorderRadiusRaw.S },
				sm: { value: BorderRadiusRaw.SM },
				m: { value: BorderRadiusRaw.M },
				l: { value: BorderRadiusRaw.L },
				xl: { value: BorderRadiusRaw.XL },
				'2xl': { value: BorderRadiusRaw['2XL'] },
				'3xl': { value: BorderRadiusRaw['3XL'] },
				'4xl': { value: BorderRadiusRaw['4XL'] }
			}
		},
		semanticTokens: {
			colors: {
				bg: {
					z0: { value: BgColorsRaw.Z0 },
					z1: { value: BgColorsRaw.Z1 },
					z2: { value: BgColorsRaw.Z2 },
					z3: { value: BgColorsRaw.Z3 },
					z4: { value: BgColorsRaw.Z4 },
					z5: { value: BgColorsRaw.Z5 },
					highlight_z0: { value: BgColorsRaw.HIGHLIGHT_Z0 },
					highlight_z1: { value: BgColorsRaw.HIGHLIGHT_Z1 },
					highlight_z2: { value: BgColorsRaw.HIGHLIGHT_Z2 },
					status_info: { value: BgColorsRaw.STATUS_INFO },
					status_warning: { value: BgColorsRaw.STATUS_WARNING },
					status_error: { value: BgColorsRaw.STATUS_ERROR },
					opposite_z2: { value: BgColorsRaw.OPPOSITE_Z2 },
					opposite_z3: { value: BgColorsRaw.OPPOSITE_Z3 },
					neutral_z0: { value: BgColorsRaw.NEUTRAL_Z0 },
					neutral_dark: { value: BgColorsRaw.NEUTRAL_DARK },
					neutral_dark_hover: { value: BgColorsRaw.NEUTRAL_DARK_HOVER }
				},
				text: {
					primary: { value: TextColorsRaw.PRIMARY },
					secondary: { value: TextColorsRaw.SECONDARY },
					tertiary: { value: TextColorsRaw.TERTIARY },
					quaternary: { value: TextColorsRaw.QUATERNARY },
					highlight_title: { value: TextColorsRaw.HIGHLIGHT_TITLE },
					highlight_action: { value: TextColorsRaw.HIGHLIGHT_ACTION },
					highlight_keyinfo: { value: TextColorsRaw.HIGHLIGHT_KEYINFO },
					status_info: { value: TextColorsRaw.STATUS_INFO },
					status_warning: { value: TextColorsRaw.STATUS_WARNING },
					status_error: { value: TextColorsRaw.STATUS_ERROR },
					status_error_darker: { value: TextColorsRaw.STATUS_ERROR_DARKER },
					status_success: { value: TextColorsRaw.STATUS_SUCCESS },
					opposite_primary: { value: TextColorsRaw.OPPOSITE_PRIMARY },
					opposite_secondary: { value: TextColorsRaw.OPPOSITE_SECONDARY },
					opposite_tertiary: { value: TextColorsRaw.OPPOSITE_TERTIARY }
				},
				brand: {
					primary: { value: BrandColorsRaw.PRIMARY },
					secondary: { value: BrandColorsRaw.SECONDARY }
				}
			}
		},
		recipes: {
			button: button,
			input: input
		},
		slotRecipes: {
			avatar: avatar
		}
	},
	globalCss: {
		html: {
			margin: 0,
			minHeight: '100%'
		},
		body: {
			margin: 0,
			minHeight: '100%',
			backgroundColor: BgColorsRaw.Z4,
			color: TextColorsRaw.PRIMARY,
			fontFamily: "'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
		}
	}
}

const customTheme = createSystem(defaultConfig, config)

export default customTheme
